import React, { useEffect } from 'react';

// reactstrap components
import { Container } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

// views
import Identificacao from "../../../views/Shared/Gerador/Identificacao";
import CaracterizacaoResiduos from "../../../views/Shared/Gerador/CaracterizacaoResiduos";
import LocaisArmazenagem from "../../../views/Shared/Gerador/LocaisArmazenagem";
import LocaisColeta from '../../../views/Shared/Gerador/LocaisColeta';
import Documentos from "../../../views/Shared/Documentos";

export default function ManutencaoGeradorRSSForm({ item, handleReturn, setupSolicitacao, addNovoGerador = false }) {

  const [protocolo, set_protocolo] = React.useState(item);

  const steps = ['Identificação', 'Caracterização dos Resíduos', 'Armazenagem dos Resíduos', 'Pontos de Coleta', 'Documentação'];
  const [step, set_step] = React.useState(0);

  const [opcao, set_opcao] = React.useState({
    tipoCadastro: "Protocolo",
    segmento: "Grande Gerador",
    categoria: { sigla: "RSS" }
  });

  useEffect(() => {
    set_opcao({
      tipoCadastro: "Protocolo",
      segmento: "Grande Gerador",
      categoria: item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria
    });
    set_protocolo(item);
  }, []);

  const handleProximoStep = (_protocolo) => {
    if (step == 4)
      handleReturn();
    else {
      set_protocolo(_protocolo);
      set_step(step + 1);
    }
  }
  const handleStepAnterior = (_protocolo) => {
    set_protocolo(_protocolo)
    set_step(step - 1);
  }



  return (
    <>
      <div className="content">
        <Container className="text-center">
          <ProgressBar stepValue={step} steps={steps} />
        </Container>
        {step == 0 &&
          <Identificacao
            item={protocolo}
            opcao={opcao}
            permiteManutencao={true}
            handleProximoStep={handleProximoStep}
            handleReturn={handleReturn}
            addNovoGerador={addNovoGerador}
            setupSolicitacao={setupSolicitacao}
          />
        }
        {step == 1 &&
          <CaracterizacaoResiduos
            item={protocolo}
            tipoCadastro="Protocolo"
            permiteManutencao={true}
            handleProximoStep={handleProximoStep}
            handleStepAnterior={handleStepAnterior}
          />
        }
        {step == 2 && 
          <LocaisArmazenagem 
            item={protocolo} 
            tipoCadastro="Protocolo" 
            permiteManutencao={true} 
            handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior} 
          />
        }
        {step == 3 && 
          <LocaisColeta 
            item={protocolo} 
            tipoCadastro="Protocolo" 
            permiteManutencao={true} 
            handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior} 
          />
        }
        {step == 4 && 
          <Documentos 
            item={protocolo} 
            opcao={opcao} 
            handleProximoStep={handleProximoStep} 
            handleStepAnterior={handleStepAnterior} 
          />
        }
      </div>
    </>
  );
}